import type { LanguagePack } from './types'

export const bn: LanguagePack = {
  navSaved: 'সেভ করা',
  navInfo: 'তথ্য',
  homeTitle: 'আপনার কাগজের একটা ছবি তুলুন',
  homeHint: 'সমঝো বলে দেবে কাগজে কী লেখা আছে আর এরপর আপনাকে কী করতে হবে।',
  takePhoto: 'ছবি তুলুন',
  uploadFile: 'ছবি বা PDF দিন',
  supportedFiles: 'ছবি (JPG, PNG, WEBP) বা PDF · 10 MB পর্যন্ত',
  chooseLanguage: 'কোন ভাষায় বুঝবেন',
  privacyLine: 'আপনার কাগজ এই ফোনেই পড়া হয়। আপনি "সেভ করুন" না টিপলে কিছুই সেভ হয় না।',

  previewTitle: 'ছবিটা ঠিক আছে তো?',
  rotate: 'ঘোরান',
  crop: 'কাটুন',
  cropDone: 'হয়ে গেছে',
  retake: 'আবার তুলুন',
  readNow: 'পড়ুন',
  docLanguageLabel: 'কাগজটা কোন ভাষায় লেখা?',
  docLanguageHint: 'ইংরেজি সবসময় সঙ্গে পড়া হয়।',

  stepCheck: 'ছবিটা দেখা হচ্ছে…',
  stepRead: 'কাগজটা পড়া হচ্ছে…',
  stepExtract: 'দরকারি কথাগুলো খোঁজা হচ্ছে…',
  stepExplain: 'বাংলায় বুঝিয়ে বলা হচ্ছে…',
  firstTimeNote: 'প্রথমবার একটু বেশি সময় লাগবে, কারণ পড়ার টুলটা ডাউনলোড হচ্ছে।',
  cancel: 'বাতিল করুন',

  errBadImage: 'ছবিটা একটু অস্পষ্ট। দয়া করে আরেকটা পরিষ্কার ছবি তুলুন।',
  errNoText: 'সমঝো এই কাগজে লেখা কিছুই খুঁজে পায়নি।',
  errUnclearPart: 'এই অংশটা সমঝো ঠিকমতো পড়তে পারেনি।',
  errUnsupportedLanguage: 'এই ভাষা এখনও চালু হয়নি।',
  errLongDocument: 'এই কাগজটা বেশ লম্বা। আগে দরকারি পাতাগুলো বেছে নিন।',
  errFileType: 'দয়া করে একটা ছবি (JPG, PNG, WEBP) বা PDF বেছে নিন।',
  errFileSize: 'এই ফাইলটা 10 MB-র চেয়ে বড়। দয়া করে ছোট ফাইল বেছে নিন।',
  errGeneric: 'কিছু একটা গোলমাল হয়েছে। দয়া করে আবার চেষ্টা করুন।',
  errOcrDownload: 'পড়ার টুলটা ডাউনলোড হয়নি। একবার ইন্টারনেট চালু করে আবার চেষ্টা করুন।',
  warnDark: 'ছবিটা অন্ধকার লাগছে। ভালো আলোয় তোলা ছবি ভালো পড়া যায়।',
  warnBlurry: 'ছবিটা ঝাপসা লাগছে। ফোনটা স্থির রেখে আবার তুলুন।',
  warnSmall: 'ছবিটা খুব ছোট। কাগজের কাছ থেকে ছবি তুলুন।',
  tryAgain: 'আবার চেষ্টা করুন',

  pickPagesHint: (max) => `বেশি হলে ${max}টা পাতা বেছে নিন।`,
  pageLabel: (n) => `পাতা ${n}`,
  readSelectedPages: (n) => `${n}টা পাতা পড়ুন`,

  typeSure: (name) => `এটা ${name} মনে হচ্ছে।`,
  typeMaybe: (name) => `এটা হয়তো ${name}, তবে সমঝো পুরোপুরি নিশ্চিত নয়।`,
  typeUnknown: 'এটা কী ধরনের কাগজ, সমঝো পুরোপুরি নিশ্চিত নয়।',
  docTypes: {
    income_certificate: { name: 'আয়ের সার্টিফিকেট', about: 'এতে সরকারি রেকর্ড অনুযায়ী কোনো মানুষ বা পরিবারের আয় লেখা থাকে।' },
    caste_certificate: { name: 'জাতির সার্টিফিকেট (কাস্ট সার্টিফিকেট)', about: 'এতে লেখা থাকে মানুষটি কোন জাতি বা শ্রেণির।' },
    domicile_certificate: { name: 'বাসিন্দা সার্টিফিকেট (ডোমিসাইল)', about: 'এতে লেখা থাকে মানুষটি স্থায়ীভাবে কোথায় থাকেন।' },
    birth_certificate: { name: 'জন্মের সার্টিফিকেট', about: 'এটা জন্মের সরকারি রেকর্ড।' },
    death_certificate: { name: 'মৃত্যুর সার্টিফিকেট', about: 'এটা মৃত্যুর সরকারি রেকর্ড।' },
    electricity_bill: { name: 'কারেন্টের বিল (বিদ্যুতের বিল)', about: 'এতে লেখা থাকে কতটা বিদ্যুৎ খরচ হয়েছে আর কত টাকা দিতে হবে।' },
    water_bill: { name: 'জলের বিল', about: 'এতে জলের জন্য কত টাকা দিতে হবে লেখা থাকে।' },
    ration_card: { name: 'রেশন কার্ড বা রেশনের নোটিস', about: 'এটা সরকারি দোকান থেকে রেশন পাওয়ার ব্যাপারে।' },
    aadhaar: { name: 'আধারের কাগজ', about: 'এটা আধার নম্বর বা আধারের তথ্যের ব্যাপারে।' },
    pan_card: { name: 'প্যানের কাগজ', about: 'এটা প্যান (ট্যাক্সের পরিচয়) নম্বরের ব্যাপারে।' },
    bank_notice: { name: 'ব্যাংকের চিঠি', about: 'এটা ব্যাংক থেকে আসা চিঠি বা নোটিস।' },
    loan_notice: { name: 'লোনের (ঋণের) নোটিস', about: 'এটা কোনো লোন বা বাকি টাকার ব্যাপারে।' },
    income_tax_notice: { name: 'ইনকাম ট্যাক্সের নোটিস', about: 'এটা ইনকাম ট্যাক্স দপ্তর থেকে এসেছে।' },
    pension: { name: 'পেনশনের চিঠি', about: 'এটা পেনশনের ব্যাপারে।' },
    court_notice: { name: 'কোর্টের বা আইনি নোটিস', about: 'এটা কোর্ট থেকে এসেছে বা কোনো আইনি ব্যাপারে। এটাকে গুরুত্ব দিন।' },
    land_record: { name: 'জমির রেকর্ড', about: 'এটা জমির মালিকানা বা জমির তথ্যের ব্যাপারে।' },
    property_tax: { name: 'বাড়ির ট্যাক্সের বিল (সম্পত্তি কর)', about: 'এটা বাড়ি বা সম্পত্তির ট্যাক্সের ব্যাপারে।' },
    scholarship: { name: 'স্কলারশিপের (বৃত্তির) চিঠি', about: 'এটা পড়াশোনার জন্য পাওয়া স্কলারশিপের ব্যাপারে।' },
    farmer_scheme: { name: 'চাষিদের প্রকল্পের চিঠি', about: 'এটা চাষিদের জন্য কোনো প্রকল্প বা সাহায্যের ব্যাপারে।' },
    school_letter: { name: 'স্কুলের চিঠি', about: 'এটা স্কুল থেকে এসেছে বা পড়াশোনার ব্যাপারে।' },
    marksheet: { name: 'মার্কশিট বা রেজাল্ট', about: 'এতে পরীক্ষার নম্বর বা রেজাল্ট লেখা আছে।' },
    insurance: { name: 'বিমার (ইনস্যুরেন্সের) কাগজ', about: 'এটা কোনো বিমা পলিসির ব্যাপারে।' },
    traffic_challan: { name: 'ট্রাফিক চালান', about: 'এটা ট্রাফিক বা গাড়ির নিয়ম ভাঙার জন্য জরিমানা।' },
    job_notice: { name: 'চাকরি বা পরীক্ষার বিজ্ঞপ্তি', about: 'এটা সরকারি চাকরি, নিয়োগ বা তার পরীক্ষা নিয়ে।' },
    application_receipt: { name: 'আবেদনের রসিদ', about: 'এটা দেখায় যে আবেদন জমা পড়েছে।' },
    application_decision: { name: 'আবেদনের ব্যাপারে চিঠি', about: 'এতে কোনো আবেদনের সিদ্ধান্ত বা খবর দেওয়া আছে।' },
    government_notice: { name: 'সরকারি নোটিস', about: 'এটা কোনো সরকারি অফিসের নোটিস বা আদেশ।' },
    lab_report: { name: 'একটি মেডিকেল পরীক্ষার রিপোর্ট', about: 'এতে রক্ত বা অন্যান্য মেডিকেল পরীক্ষার ফলাফল আছে।' },
    rental_agreement: { name: 'একটি ভাড়ার চুক্তি', about: 'এটি বাড়িওয়ালা ও ভাড়াটের মধ্যে চুক্তি।' },
    loan_agreement: { name: 'একটি ঋণ চুক্তি', about: 'এতে ঋণের শর্ত আছে: সুদ, EMI আর চার্জ।' },
    contract: { name: 'একটি চুক্তি', about: 'এটি একটি চুক্তি, যার শর্ত দুই পক্ষকেই মানতে হয়।' },
    unknown: { name: 'একটা কাগজ', about: '' }
  },

  seedhiBaat: 'সোজা কথায়',
  docSays: 'কাগজে লেখা আছে',
  samjhoSays: 'সমঝো বুঝিয়ে বলছে',
  unclearText: 'এই অংশটা পরিষ্কার পড়া যায়নি — দয়া করে আসল কাগজটা দেখুন।',

  aboutPerson: (name) => `এই কাগজটা এঁর ব্যাপারে: ${name}।`,
  issuedBy: (authority) => `এটা এখান থেকে এসেছে: ${authority}।`,
  status: {
    approved: 'আবেদন মঞ্জুর হয়েছে।',
    rejected: 'আবেদন নামঞ্জুর (রিজেক্ট) হয়েছে।',
    pending: 'আবেদনের কাজ এখনও চলছে। এখনও কোনো সিদ্ধান্ত হয়নি।',
    cancelled: 'এটা বাতিল করা হয়েছে।'
  },
  dateSentence: {
    deadline: (d) => `শেষ তারিখ: ${d}।`,
    due: (d) => `টাকা দেওয়ার শেষ তারিখ: ${d}।`,
    hearing: (d) => `কাগজে হাজির থাকার জন্য এই তারিখ দেওয়া আছে: ${d}।`,
    issue: (d) => `এই কাগজটা ${d} তারিখে দেওয়া হয়েছে।`,
    validity: (d) => `এটা ${d} পর্যন্ত বৈধ।`,
    birth: (d) => `জন্মের তারিখ লেখা আছে: ${d}।`,
    other: (d) => `একটা তারিখ লেখা আছে: ${d}।`
  },
  daysLeft: (days) => `আর ${days} দিন বাকি আছে।`,
  dueToday: 'এই তারিখটা আজই।',
  datePassed: 'খেয়াল করুন: এই তারিখটা পেরিয়ে গেছে।',
  amountSentence: {
    payable: (a) => `কত টাকা দিতে হবে: ${a}।`,
    income: (a) => `আয় লেখা আছে: ${a}।`,
    fine: (a) => `জরিমানা বা দেরির চার্জ লেখা আছে: ${a}।`,
    fee: (a) => `ফি লেখা আছে: ${a}।`,
    sanctioned: (a) => `মঞ্জুর হওয়া বা পাঠানো টাকা: ${a}।`,
    other: (a) => `একটা টাকার অঙ্ক লেখা আছে: ${a}।`
  },
  actionsPointer: 'কাগজে আপনাকে কিছু করতে বলা হয়েছে। নিচে "আপনাকে কী করতে হবে" দেখুন।',
  noActionFound: 'কাগজে আপনাকে কিছু করতে বলা হয়েছে কিনা, তা পরিষ্কার লেখা নেই।',
  keepSafe: 'এই কাগজটা যত্ন করে রেখে দিন।',
  doBefore: (d) => `${d} তারিখের আগে এই কাজটা করুন।`,
  bringDocs: (list) => `এই কাগজগুলো হাতের কাছে রাখুন: ${list}।`,
  contactFor: (c) => `কিছু জানার থাকলে এখানে যোগাযোগ করুন: ${c}।`,
  warningPointer: 'কাগজে একটা সাবধানবাণী লেখা আছে। সেটা মন দিয়ে পড়ুন।',
  rejectedNext: 'আপনার যদি মনে হয় ভুল হয়েছে, তাহলে যে অফিস থেকে এই চিঠি এসেছে, সেখানে জিজ্ঞেস করুন।',
  lowQuality: 'ছবিটা খুব পরিষ্কার ছিল না, তাই কিছু কথা ভুল পড়া হয়ে থাকতে পারে। আসল কাগজের সঙ্গে মিলিয়ে নিন।',

  cardTodo: 'আপনাকে কী করতে হবে',
  cardDates: 'দরকারি তারিখ',
  cardAmount: 'টাকার অঙ্ক',
  cardWhere: 'কোথায় যেতে হবে',
  cardWarnings: 'সাবধান',
  cardDocs: 'কী কী কাগজ লাগবে',
  cardPerson: 'কার ব্যাপারে',
  cardFrom: 'কে পাঠিয়েছে',
  cardNumbers: 'দরকারি নম্বর',
  cardContact: 'যোগাযোগ',
  refKinds: {
    application: 'আবেদন নম্বর',
    certificate: 'সার্টিফিকেট নম্বর',
    consumer: 'কনজিউমার নম্বর',
    account: 'অ্যাকাউন্ট নম্বর',
    case: 'কেস নম্বর',
    reference: 'চিঠির নম্বর',
    registration: 'রেজিস্ট্রেশন নম্বর',
    receipt: 'রসিদ নম্বর',
    other: 'নম্বর'
  },
  requiredDocNames: {
    aadhaar: 'আধার কার্ড',
    pan: 'প্যান কার্ড',
    ration_card: 'রেশন কার্ড',
    voter_id: 'ভোটার কার্ড',
    passbook: 'ব্যাংকের পাসবই',
    photo: 'ছবি',
    income_certificate: 'আয়ের সার্টিফিকেট',
    caste_certificate: 'জাতির সার্টিফিকেট',
    domicile_certificate: 'বাসিন্দা সার্টিফিকেট',
    birth_certificate: 'জন্মের সার্টিফিকেট',
    land_record: 'জমির রেকর্ড',
    electricity_bill: 'কারেন্টের বিল',
    address_proof: 'ঠিকানার প্রমাণ',
    id_proof: 'পরিচয়ের প্রমাণ',
    affidavit: 'হলফনামা (এফিডেভিট)',
    application_form: 'আবেদনের ফর্ম'
  },

  voiceDownloadNote: 'প্রথমবার ভয়েস ডাউনলোড হচ্ছে (প্রায় 58 MB)। তারপর ইন্টারনেট ছাড়াও চলবে।',

  listen: 'শুনুন',
  pause: 'থামান',
  resume: 'বাকিটা শুনুন',
  stop: 'বন্ধ করুন',
  noVoice: 'এই ফোনে বাংলার ভয়েস (আওয়াজ) নেই।',
  noVoiceHint: 'ফোনের সেটিং-এ (Text-to-speech) ভয়েস যোগ করতে পারেন, অথবা অন্য ভাষায় শুনুন।',
  listenInHindi: 'হিন্দিতে শুনুন',
  listenInEnglish: 'ইংরেজিতে শুনুন',
  noSpeechSupport: 'এই ব্রাউজার জোরে পড়ে শোনাতে পারে না।',

  disclaimer: 'সমঝো আপনার কাগজটা সহজ করে বোঝায়। দরকারি কথাগুলো সবসময় আসল কাগজ বা যে অফিস কাগজটা দিয়েছে, তাদের সঙ্গে মিলিয়ে নিন। সমঝো কোনো সরকারি পরিষেবা নয়, আর এটা আইনি পরামর্শ নয়।',
  fullText: 'সমঝো কী পড়েছে',
  fullTextHint: 'রং করা লাইনগুলো পরিষ্কার পড়া যায়নি।',
  newDocument: 'নতুন কাগজ',
  save: 'এই ফোনে সেভ করুন',
  saved: 'এই ফোনে সেভ হয়ে গেছে',
  share: 'শেয়ার করুন',
  copied: 'কপি হয়ে গেছে',
  translateLines: 'কাগজের ইংরেজি লাইনগুলো বাংলায় দেখুন',
  helperMode: 'হেল্পার মোড',
  helperModeHint: 'যাঁরা অন্যদের কাগজ পড়ে দেন তাঁদের জন্য (CSC, NGO, স্বেচ্ছাসেবক)। এতে সেভ বন্ধ থাকে, আর "পরের জন" চাপলে সব মুছে যায়।',
  nextPerson: 'পরের জন',
  listenMode: 'শোনার মোড',
  listenModeHint: 'ব্যাখ্যা তৈরি হলেই সমঝো নিজে থেকে পড়ে শোনায়।',
  settingsTitle: 'সেটিংস',
  shareVoiceNote: 'ভয়েস নোট পাঠান',
  makingVoiceNote: 'ভয়েস নোট তৈরি হচ্ছে…',
  voiceNoteFailed: 'এই ফোনে ভয়েস নোট তৈরি করা গেল না।',
  translateOtherLines: 'কাগজের অন্য ভাষার লাইনগুলো বাংলায় দেখুন',
  translateAiNote: 'যে লাইনগুলো ইংরেজিতে নয়, সেগুলো একটি AI পরিষেবা (Groq) অনুবাদ করে।',
  translateConsent: 'অনুবাদ করার জন্য এই লাইনগুলো ইন্টারনেটে সমঝোর সার্ভারে পাঠানো হবে। সেখানে সেভ করা হয় না। আধার আর ফোনের মতো নম্বর আগেই সরিয়ে দেওয়া হয়।',
  translateConfirm: 'হ্যাঁ, অনুবাদ করুন',
  translating: 'অনুবাদ হচ্ছে…',
  translateNote: 'মেশিনে করা অনুবাদ — ভুল থাকতে পারে।',
  translateFailed: 'এখন অনুবাদ করা যাচ্ছে না।',
  retryRotated: 'ছবি ঘুরিয়ে আবার পড়ুন',

  addToCalendar: 'ক্যালেন্ডারে রিমাইন্ডার যোগ করুন',
  askTitle: 'এই কাগজ নিয়ে প্রশ্ন করুন',
  askHint: 'নিজের ভাষায় জিজ্ঞেস করুন। সমঝো আপনার কাগজ থেকে উত্তর দেবে — আর সেখানে না থাকলে, শুধু সরকারি ওয়েবসাইট থেকে।',
  askPlaceholder: 'আপনার প্রশ্ন লিখুন বা বলুন…',
  askSend: 'জিজ্ঞেস করুন',
  askMic: 'বলে জিজ্ঞেস করুন',
  askListening: 'শুনছি… এখন বলুন',
  askWebToggle: 'দরকার হলে সরকারি ওয়েবসাইটও দেখা হবে',
  askConsent: 'উত্তর দিতে এই কাগজের লেখা আর আপনার প্রশ্ন ইন্টারনেটে সমঝোর সার্ভার আর একটি AI পরিষেবায় (Groq) পাঠানো হবে। আধার, প্যান, ফোন নম্বর আর ইমেল আগেই সরিয়ে দেওয়া হয়। কিছুই সেভ করা হয় না।',
  askOfficialOnly: 'শুধু সরকারি ওয়েবসাইট দেখা হয়, যেমন:',
  askConsentConfirm: 'ঠিক আছে, জিজ্ঞেস করুন',
  askThinkingDoc: 'আপনার কাগজ পড়া হচ্ছে',
  askThinkingWeb: 'সরকারি ওয়েবসাইট দেখা হচ্ছে',
  askFromDoc: 'আপনার কাগজ থেকে',
  askFromWeb: 'সরকারি ওয়েবসাইট থেকে',
  askNotFound: 'সমঝো এটা আপনার কাগজে বা সরকারি ওয়েবসাইটে খুঁজে পায়নি। যে অফিস এই কাগজ পাঠিয়েছে, তাদের জিজ্ঞেস করুন।',
  askUnverified: 'সমঝো এটা কাগজের কোনো নির্দিষ্ট লাইনের সাথে মেলাতে পারেনি। কাগজটা দেখে যাচাই করুন।',
  askSources: 'সূত্র',
  askOfficial: 'সরকারি',
  askFailed: 'এখন উত্তর পাওয়া গেল না। আবার চেষ্টা করুন।',
  askBusy: 'এখন অনেক প্রশ্ন আসছে। এক মিনিট পরে আবার জিজ্ঞেস করুন।',
  askAiNote: 'এই উত্তরগুলো AI লিখেছে, ভুল থাকতে পারে। জরুরি কথা অফিস থেকে যাচাই করে নিন।',
  askTryNext: 'আপনি এটাও জিজ্ঞেস করতে পারেন:',
  askJump: 'প্রশ্ন করুন',
  askSuggest: {
    fillForm: 'এই ফর্ম কীভাবে পূরণ করব? প্রতিটি ঘর বুঝিয়ে দিন।',
    first: 'আমাকে আগে কী করতে হবে?',
    deadline: 'শেষ তারিখ পেরিয়ে গেলে কী হবে?',
    pay: 'এটা কীভাবে আর কোথায় জমা দেব?',
    papers: 'এই কাগজগুলো কোথা থেকে পাব?',
    rejected: 'এটা কেন বাতিল হল, আর এখন আমি কী করতে পারি?',
    meaning: 'এই কাগজটা খুব সহজ ভাষায় বুঝিয়ে দিন।',
    contact: 'এ বিষয়ে কার সাথে যোগাযোগ করব?',
    schemes: 'এই কাগজ অনুযায়ী আমি কোন সরকারি প্রকল্পের যোগ্য হতে পারি?'
  },

  helpTitle: 'সাহায্য নিন',
  nearbyTitle: 'সবচেয়ে কাছের অফিস',
  nearbyNote: 'আপনার কাছের ম্যাপ খুলবে। আপনার লোকেশন শুধু ম্যাপে যায় — সমঝো সেটা দেখে না, সেভও করে না।',
  locating: 'আপনার লোকেশন খোঁজা হচ্ছে…',
  schemesTitle: 'সরকারি প্রকল্প',
  schemesText: 'এই কাগজ অনুযায়ী কোন প্রকল্প আপনার কাজে লাগতে পারে, সমঝো সরকারি প্রকল্পের ওয়েবসাইটে দেখে নিতে পারে।',
  schemesButton: 'আমার জন্য প্রকল্প খুঁজুন',
  legalTitle: 'বিনামূল্যে আইনি সাহায্য',
  legalText: 'আইনি পরিষেবা কর্তৃপক্ষ থেকে আপনি বিনামূল্যে উকিল পেতে পারেন — যেমন মহিলা, শিশু, SC/ST, শ্রমিক, প্রতিবন্ধী ও কম আয়ের মানুষ।',
  legalCall: (n) => `${n}-এ ফোন করুন (বিনামূল্যে)`,
  legalNearby: 'সবচেয়ে কাছের আইনি পরিষেবা কর্তৃপক্ষ',
  legalMore: 'আরও আইনি সাহায্য',
  legalAskConsent: 'আপনার প্রশ্ন ইন্টারনেটে সমঝোর সার্ভার আর একটি AI পরিষেবায় (Groq) পাঠানো হবে, যা উত্তর শুধু সরকারি ওয়েবসাইটে খোঁজে। আধার, প্যান, ফোন নম্বর আর ইমেল আগেই সরিয়ে দেওয়া হয়। কিছুই সেভ করা হয় না।',
  navLegal: 'আইনি সাহায্য'
}
